import { render, staticRenderFns } from "./roiPirate.vue?vue&type=template&id=1096ed1a&scoped=true&"
import script from "./roiPirate.vue?vue&type=script&lang=js&"
export * from "./roiPirate.vue?vue&type=script&lang=js&"
import style0 from "./roiPirate.vue?vue&type=style&index=0&id=1096ed1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1096ed1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1096ed1a')) {
      api.createRecord('1096ed1a', component.options)
    } else {
      api.reload('1096ed1a', component.options)
    }
    module.hot.accept("./roiPirate.vue?vue&type=template&id=1096ed1a&scoped=true&", function () {
      api.rerender('1096ed1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataPirate/roiPirate.vue"
export default component.exports